import { styled } from '@linaria/react';
import { bodyFont, colors, space } from '../../theme/tokens';

export const EmptyMessage = styled.p`
  font-family: ${bodyFont};
  font-size: 1rem;
  color: ${colors.fontSecondary};
  text-align: center;
  padding: ${space[8]} 0;
`;
